var map = {
	"./category/index.js": 1064,
	"./company/index.js": 1135,
	"./customer/index.js": 1181,
	"./device/index.js": 1194,
	"./discount/index.js": 1202,
	"./optional-groups/index.js": 1217,
	"./payment/index.js": 1227,
	"./product/index.js": 1273,
	"./user/index.js": 1339,
	"./variation/index.js": 1346
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2741;


//////////////////
// WEBPACK FOOTER
// ./src/components/app/registration \.\/[^\/]+\/index\.jsx?$
// module id = 2741
// module chunks = 0